<script setup lang="ts">
import { api } from '@/api';
import { type NumericQuantityDto } from '@/api/generator';
import PtwBackButton from '@/components/buttons/PtwBackButton.vue';
import { useVeeForm } from '@/components/forms/useVeeForm';
import BasePage from '@/components/pages/BasePage/BasePage.vue';
import BasePageStatus from '@/components/pages/BasePage/BasePageStatus.vue';
import BasePageTitle from '@/components/pages/BasePage/BasePageTitle.vue';
import { routenames } from '@/router/routenames';
import { translateEntityProperty } from '@/utils/helper.ts';
import { useLoading } from '@/utils/useLoading';
import { onMounted } from 'vue';
import QuantityForm from './components/QuantityForm.vue';
import { entityNotFoundErrorHandler } from '@/errorHandling';
import { useRouter } from 'vue-router';

export interface QuantityDetailsViewProps {
  id: string;
}

const props = defineProps<QuantityDetailsViewProps>();

const router = useRouter();

const { action: loadQuantity, loading } = useLoading(async () => {
  const { result } = await api.numericQuantitiesApi.getNumericQuantity(
    {
      id: props.id,
    },
    [entityNotFoundErrorHandler(router)],
  );

  if (result) {
    resetForm({ values: result });
  }
}, true);

const {
  form: { values, resetForm },
} = useVeeForm<NumericQuantityDto>({
  mode: 'details',
});

onMounted(loadQuantity);
</script>

<template>
  <BasePage :loading="loading">
    <template #title>
      <BasePageTitle
        :subtitle="$t('Quantity_one')"
        :title="translateEntityProperty('name', values)"
        :titleId="values.iuid"
      />
    </template>

    <template #status>
      <BasePageStatus :entity="values" />
    </template>

    <template #actions>
      <PtwBackButton :to="{ name: routenames.quantities.overview }" />
    </template>

    <QuantityForm />
  </BasePage>
</template>
